<template>
	<div class="file-size-progress">
		<span class="total-file-size">Total : {{ (totalSize / 1024 / 1024).toFixed(2) }} / 100 Mo</span>
		<div class="progress-bar">
			<div class="progress-gray"></div>
			<div class="progress-orange" :style="{ width: progress + '%' }"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "FileSizeProgress",
	props: {
		propID: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			totalSize: 0,
			progress: 0,
		};
	},
	methods: {
		async fetchTotalSize() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + `size/${this.propID}`, { credentials: "include", });
				const data = await response.json();

				this.totalSize = data.totalSize;
				this.updateProgress();
			} catch (error) {
				console.error("Error fetching total size:", error);
			}
		},
		updateProgress() {
			const maxSize = 100 * 1024 * 1024;
			this.progress = (this.totalSize / maxSize) * 100;
		},
		reset() {
			this.fetchTotalSize();
		},
	},
	mounted() {
		this.fetchTotalSize();
	},
};
</script>

<style>
.file-size-progress {
	display: flex;
	flex-direction: column;
}

.file-size-progress .total-file-size {
	font-size: 14px;
	white-space: nowrap;
}

.file-size-progress .progress-bar {
	width: 100%;
	height: 5px;
	position: relative;
}

.file-size-progress .progress-gray {
	background-color: #ccc;
	width: 100%;
	height: 100%;
}

.file-size-progress .progress-orange {
	background-color: #ff8017;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
}
</style>
